// src/Pages/Writing.jsx
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Link as RouterLink } from "react-router-dom";
import { ThemeProvider, createTheme, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footer from "./Footer";

export default function Writing() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "2.2rem",
        fontWeight: 200,
        [base.breakpoints.down("sm")]: {
          fontSize: "1.6rem",
          fontWeight: 300,
        },
      },
    },
  });

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const linkGridStyle = {
    color: "black",
    textDecoration: "none",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    alignItems: "start",
    columnGap: "0.25rem",
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="start"
        height="88vh"
        marginTop="5vh"
        maxWidth="100vw"
      >
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="flex-start"
          maxWidth="100vw"
        >
          {/* Title */}
          <Grid item xs={12} sx={{ mb: "5vh" }}>
            <Typography
              variant="h1"
              component={RouterLink}
              to="/"
              sx={{
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              // writing
            </Typography>
          </Grid>

          {/* Links block */}
          <Grid
            item
            sx={{
              width: isMobile ? "80vw" : "auto",
              display: "flex",
              flexDirection: "column",
              gap: 1.2,
            }}
          >
            <Typography variant="body1">
              <RouterLink to="/writing/chereamie_1" style={linkGridStyle}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>
                  Chère Amie <span style={{ fontSize: "0.6em" }}>(#1)</span>
                </span>
              </RouterLink>
            </Typography>

            <Typography variant="body1" marginTop="5vh">
              <a
                href="https://letterboxd.com/hennibbale/films/reviews"
                target="_blank"
                rel="noreferrer"
                style={linkGridStyle}
              >
                <span aria-hidden="true">//&nbsp;</span>
                <span>
                  movie reviews{" "}
                  <span style={{ fontSize: "0.6em" }}>(letterboxd)</span>
                </span>
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </ThemeProvider>
  );
}
